var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"margin-top":"-12px","padding-right":"0px"},attrs:{"fluid":""}},[_c('DataViewer',{ref:"dataViewer",staticStyle:{"padding-right":"0px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }